import { Component, OnInit } from '@angular/core';
import {Globals}from "../../_models/globals";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import {User} from "../../_models/user";
import {ApiIntegration}from '../../_services/api.integration';

@Component({
  selector: 'app-delhivery-manage',
  templateUrl: './delhivery-manage.component.html',
  styleUrls: ['./delhivery-manage.component.scss'],
})
export class DelhiveryManageComponent implements OnInit {

carrierNameError: string;
tokenError: string;
delhiveryData: any = {};
carrierId: string;

  constructor(private api: ApiIntegration, private alertService: AlertService,private  g : Globals , private user : User , private http : HttpClient , private router : Router , private route : ActivatedRoute) {

  this.carrierId = this.route.snapshot.paramMap.get('id');
  if(this.carrierId){
  this.api.getCarrierInfoById(this.user.accountOwnerId,this.carrierId,this.user.organizationId).subscribe((data: any) => {
          this.delhiveryData = data;
        }, err => {
           this.alertService.error('Error',err);
        });
  }
}



  carrierNameBlur(){
    this.carrierNameError ="";
      if (!this.delhiveryData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
      }
    }

  tokenBlur(){
    this.tokenError ="";
      if (!this.delhiveryData.token) {
      this.tokenError = 'Please enter token';
      }
    }


  ngOnInit() {}

  verify(){

    this.g.loaderDisplay = "display";
    this.carrierNameError= "";
    this.tokenError= "";

      if (!this.delhiveryData.connectionName) {
           this.carrierNameError = 'Please enter carrier name';
       }
      if (!this.delhiveryData.token) {
        this.tokenError = 'Please enter token';
      }
      if (this.carrierNameError != "" ||this.tokenError != "") {
        this.g.loaderDisplay = "";
        return false;
      }
 // api body

     var header1 = new HttpHeaders();
     header1 = header1.append('Content-Type', 'application/json');
     header1 = header1.append('Accept', 'application/json');
     header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
     this.http.post(environment.apiUrl + 'api/updateCarrierCredentials',{
          "token": this.delhiveryData.token,
          "accountOwnerId": this.delhiveryData.accountOwnerId,
          "carrierCode": this.delhiveryData.carrierCode,
          "connectionName": this.delhiveryData.connectionName,
          "organizationId": this.delhiveryData.organizationId,
          "carrierId": this.delhiveryData.carrierId
       },
       {headers: header1}).subscribe(data => {
         this.g.loaderDisplay = "";
         if(data['code'] == 200) {
         this.alertService.success('Delhivery','Create Successfully');
           this.router.navigate(['/admin/customerCarriers']);
         }
          else {
              this.alertService.error('Error',data['message']);
           }
       },
       (err: HttpErrorResponse) => {
         this.g.loaderDisplay = "";
         console.log(err);
       })
  }

}

